import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "AW-17447713761", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

export default usePageTracking;
